import { fetchPsap } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { selectUserOrgByApp } from '@rsos/sinatra';
import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';
import { captureExceptionWithScope } from '@rsos/utils/sentry';
import serializeRequestError from '@rsos/utils/serializeRequestError';
import fetchRetry from '../../fetchRetry';
import {
  UPDATE_PSAP_INFO_START,
  UPDATE_PSAP_INFO_SUCCESS,
  UPDATE_PSAP_INFO_FAILED,
} from '../actionTypes';

const baseURL = `${getAPIHost()}/v1/capstone`;

export const updatePSAPInfoStart = () => ({
  type: UPDATE_PSAP_INFO_START,
});

export const updatePSAPInfoFail = error => {
  return {
    type: UPDATE_PSAP_INFO_FAILED,
    error,
  };
};

export const updatePSAPInfoSuccess = psapInfo => {
  return {
    type: UPDATE_PSAP_INFO_SUCCESS,
    psapInfo,
  };
};

export const updatePSAPInfo = currentPSAPdata => (dispatch, getState) => {
  dispatch(updatePSAPInfoStart());
  const { sinatra } = getState();
  const { token, tokenExpiration, refreshExpiration } = sinatra.auth.tokens;
  const application = sinatra.user.currentRole.application;
  const org = selectUserOrgByApp(sinatra, application);

  const endpoint = `${baseURL}/psaps/${org.name}`;
  const options = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
    body: JSON.stringify(currentPSAPdata),
  };

  return fetchRetry(endpoint, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(() => {
      // Refresh the shared psaps slice from the server after a successful save.
      return dispatch(fetchPsap(`/psaps/${org.name}`));
    })
    .catch(async err => {
      captureExceptionWithScope(err, {
        extra: {
          accessTokenExpiration: tokenExpiration,
          refreshTokenExpiration: refreshExpiration,
        },
      });
      const serializedError = await serializeRequestError(err);
      throw dispatch(updatePSAPInfoFail(serializedError));
    });
};

export default updatePSAPInfo;
